import { z } from 'zod';
import { buddyProfileSchema, type BuddyProfile } from './companionApi';

const draftProfileSchema = buddyProfileSchema.extend({ name: z.string().max(12) });
const storedDraftSchema = z.object({
  version: z.literal(1),
  baseProfile: buddyProfileSchema.nullable(),
  profile: draftProfileSchema,
});
const key = (kidId: string) => `airbotix:buddy-draft:v1:${kidId}`;
const signature = (profile: BuddyProfile | null) =>
  JSON.stringify(profile ? buddyProfileSchema.parse(profile) : null);

/** Device-local unfinished appearance only. No chat, memory or account credentials. */
export function loadBuddyDraft(
  kidId: string,
  savedProfile: BuddyProfile | null,
): BuddyProfile | null {
  try {
    const stored = localStorage.getItem(key(kidId));
    if (!stored) return null;
    const draft = storedDraftSchema.parse(JSON.parse(stored));
    // A draft must never silently replace a different look saved on another device.
    return signature(draft.baseProfile) === signature(savedProfile) ? draft.profile : null;
  } catch {
    return null;
  }
}
export function saveBuddyDraft(
  kidId: string,
  baseProfile: BuddyProfile | null,
  value: unknown,
): boolean {
  try {
    const profile = draftProfileSchema.parse(value);
    localStorage.setItem(key(kidId), JSON.stringify({ version: 1, baseProfile, profile }));
    return true;
  } catch {
    return false;
  }
}
export function clearBuddyDraft(kidId: string): void {
  try {
    localStorage.removeItem(key(kidId));
  } catch {
    /* Cloud save remains authoritative. */
  }
}
